import { apiFactory } from "../api_factory";

export const talliesApi = apiFactory({
  path: "/api/v3/survey/tally",
  usePostForGet: true
});
